export enum ErrorLevel {
  FATAL = 'fatal',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  DEBUG = 'debug',
}

export type AcceptableTags = number | string | boolean;

type captureExceptionFunction = (
  error: string | Error,
  additionalTags?: Record<string, AcceptableTags>,
  additionalInfo?: Record<string, unknown>
) => void;

export type LoggerAdapter = {
  init: () => void;
  fatal: captureExceptionFunction;
  error: captureExceptionFunction;
  warning: captureExceptionFunction;
  info: captureExceptionFunction;
  debug: captureExceptionFunction;
};

export type InternalLogger = {
  init?: () => void;
  captureError: (
    errorLevel: ErrorLevel,
    error: Error | string,
    additionalTags?: Record<string, AcceptableTags>,
    additionalInfo?: Record<string, unknown>
  ) => void;
};
